export default __webpack_public_path__ + "media/images/banners/bnr_willer-4b8c5115d309affe86ce471738181370.jpg";